
import axios from 'axios'
import {get, post } from './index'

/**
 * @description 登录获取token
 */
export const loginApi = async ({ data , headers} :{data: Record<string, any>, headers: Record<string, any>}) => {
    return post(`/app/xcx/login`, data, {headers})
}

/**
 * @description 获取建筑树
 * @param data 
 * @returns 
 */
export const getBuildingInfoApi = async (data: Record<string, any>) => {
    return get(`/nkd/gettreebyparentwithused`, data)
}

/**
 * @description 绑定房间
 * @param data 
 * @returns 
 */
export const bindRoomApi = async (data: Record<string, any>) => {
    return post(`/nkd/bindbuild`, data)
}
/**
 * @description 解除房间绑定
 * @param data 
 * @returns 
 */
export const delRoomApi = async (data: Record<string, any>) => {
    return post(`/nkd/unbindbuild`, data)
}

/**
 * @description 绑定房间下面的表计
 * @param data 
 * @returns 
 */
export const getbindmonitorApi = async (data: Record<string, any>) => {
    return get(`/nkd/getbindmonitor`, data)
}
/**
 * @description 获取签名
 * @param data 
 * @returns 
 */
export const getSignApi = async (data: Record<string, any>) => {
    return post(`/nkd/pay/sign`, data)
}

/**
 * @description 预充值
 * @param data 
 * @returns 
 */
export const getPrepayApi = async (data: Record<string, any>) => {
    return post(`/nkd/pay/newprepay`, data)
}

/**
 * @description ticket换取sid
 * @param data 
 * @returns 
 */
export const getnkdSidApi = async (data: Record<string, any>) => {
    return get(`/app/xcx/nkd/login`, data)
}


/**
 * @description 缴费记录
 * @param data 
 * @returns 
 */
export const getChargeListApi = async (data: Record<string, any>) => {
    return get(`/nkd/charge/list`, data)
}

/**
 * @description 查询用能数据
 * @param data 
 * @returns 
 */
export const getDayUseEnergyApi = async (data: Record<string, any>) => {
    return get(`/nkd/getDayUseEnergy`, data)
}

/**
 * @description 设置报警阈值
 * @param data 
 * @returns 
 */
export const updateWarnMoneyApi = async (data: Record<string, any>) => {
    return post(`/nkd/updatewarnmoney`, data)
}

/**
 * @description 获取表计默认阈值
 * @param data 
 * @returns 
 */
export const getDefaultWarnMoneyApi = async () => {
    return get(`/nkd/defaultwarnmoney`)
}

/**
 * @description 根据房间获取表计默认阈值
 * @param data 
 * @returns 
 */
export const getRoomIdDefaultWarnMoneyApi = async (roomid: string) => {
    return get(`/nkd/defaultwarnmoney/${roomid}`)
}
export const getWarningInfoApi = async () => {
 /*    return get2('https://sdsfpt.sustech.edu.cn/warning.json') */
    return  axios.get('https://sdsfpt.sustech.edu.cn/warning.json',{
        headers: {
            'Cache-Control': 'no-cache',
        }
       })
  }